import React, { useEffect } from "react";
import { Container, Alert, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function OnboardingComplete() {
  const navigate = useNavigate();

  useEffect(() => {
    // Optionally refresh user data here to update Connect status
    // You could also show a success toast
  }, []);

  const handleViewDashboard = () => {
    navigate("/auth/referrals");
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Card className="text-center" style={{ maxWidth: "500px", width: "100%" }}>
        <Card.Body className="p-5">
          <div className="text-success mb-3" style={{ fontSize: '4rem' }}>✅</div>
          <Card.Title className="h3 mb-3">Setup Complete!</Card.Title>
          <Card.Text className="mb-4">
            Great! Your payout account has been successfully set up. You can now receive 
            cash payouts directly to your bank account when users subscribe using your referral code.
          </Card.Text>
          
          <Alert variant="info" className="text-start">
            <Alert.Heading className="h6">What's Next?</Alert.Heading>
            <ul className="mb-0 small">
              <li><strong>Monthly Plans:</strong> Earn $8 every month when referrals renew</li>
              <li><strong>Yearly Plans:</strong> Earn $60 upfront when referrals subscribe</li>
              <li><strong>Automatic Payouts:</strong> Money sent directly to your bank account</li>
            </ul>
          </Alert>

          <div className="d-grid gap-2">
            <Button variant="primary" size="lg" onClick={handleViewDashboard}>
              View Referral Dashboard
            </Button>
            <Button variant="outline-secondary" onClick={() => navigate("/auth")}>
              Go to Dashboard
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
} 